import React from 'react';
import { Box, Typography, Link, Container, Button } from '@mui/material';

interface FooterProps {
  onLinkClick: (pageKey: 'about' | 'privacy' | 'terms') => void;
}

const Footer: React.FC<FooterProps> = ({ onLinkClick }) => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 2, sm: 3 },
        px: 2,
        mt: 'auto',
        backgroundColor: 'white',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        width: '100%',
        marginBottom: 0
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: { xs: 2, sm: 2 },
            flexWrap: 'wrap'
          }}
        >
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{
              fontSize: { xs: '0.7rem', sm: '0.875rem' },
              textAlign: { xs: 'left', sm: 'left' },
              opacity: 0.8,
              order: { xs: 2, sm: 1 }
            }}
          >
            © {new Date().getFullYear()} Tenaba, Inc. All rights reserved.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 2, sm: 3 },
              flexWrap: 'nowrap',
              justifyContent: 'flex-end',
              width: 'auto',
              order: { xs: 1, sm: 2 }
            }}
          >
            <Button
              variant="text"
              onClick={() => onLinkClick('about')}
              sx={{ 
                p: 0,
                minWidth: 'auto',
                textTransform: 'none',
                color: 'text.secondary',
                fontSize: { xs: '0.7rem', sm: '0.875rem' },
                opacity: 0.8,
                transition: 'opacity 0.2s ease',
                whiteSpace: 'nowrap',
                '&:hover': {
                  opacity: 1,
                  backgroundColor: 'transparent'
                }
              }}
            >
              About
            </Button>
            <Button
              variant="text"
              onClick={() => onLinkClick('privacy')}
              sx={{ 
                p: 0,
                minWidth: 'auto',
                textTransform: 'none',
                color: 'text.secondary',
                fontSize: { xs: '0.7rem', sm: '0.875rem' },
                opacity: 0.8,
                transition: 'opacity 0.2s ease',
                whiteSpace: 'nowrap',
                '&:hover': {
                  opacity: 1,
                  backgroundColor: 'transparent'
                }
              }}
            >
              Privacy Policy
            </Button>
            <Button
              variant="text"
              onClick={() => onLinkClick('terms')}
              sx={{ 
                p: 0,
                minWidth: 'auto',
                textTransform: 'none',
                color: 'text.secondary',
                fontSize: { xs: '0.7rem', sm: '0.875rem' },
                opacity: 0.8,
                transition: 'opacity 0.2s ease',
                whiteSpace: 'nowrap',
                '&:hover': {
                  opacity: 1,
                  backgroundColor: 'transparent'
                }
              }}
            >
              Terms of Service
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 